{
  "familyId": "GET-BREUK-GEL-MIN",
  "questions": [
    {
      "id": "GET-BREUK-GEL-MIN-001",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{3}{4}$ - $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{2}{4}$", "$\\frac{4}{8}$", "$\\frac{2}{8}$", "$\\frac{4}{4}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_quarters",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "fractions": [
              {"numerator": 3, "denominator": 4, "label": "3/4"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 4,
            "label": "3/4 - 1/4 = 2/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de tellers af — de noemer blijft hetzelfde. Hier: 3 - 1 = 2, en de noemer blijft 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$. Vereenvoudigd is dat $\\frac{1}{2}$. Onthoud: bij gelijknamige breuken verandert de noemer niet!",
        "solutionSteps": [
          "Zijn de noemers gelijk? Ja, allebei 4 (gelijknamig)",
          "Trek de tellers af: 3 - 1 = 2",
          "De noemer blijft hetzelfde: 4",
          "Antwoord: $\\frac{2}{4}$ (= $\\frac{1}{2}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 3 - 1 = 2, noemer blijft 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (4 + 4 = 8). Maar bij gelijknamige breuken blijft de noemer hetzelfde. Je rekent alleen met de tellers: 3 - 1 = 2. Onthoud: de noemer verandert niet bij gelijknamige breuken.",
          "2": "Je dacht waarschijnlijk dat je zowel de tellers aftrekt (3 - 1 = 2) als de noemers optelt (4 + 4 = 8). Maar de noemer blijft 4, niet 8. Onthoud: bij gelijknamige breuken reken je alleen met de tellers.",
          "3": "Je dacht waarschijnlijk dat je de tellers moet optellen (3 + 1 = 4) in plaats van aftrekken. Maar het minteken zegt: trek af. 3 - 1 = 2, dus $\\frac{2}{4}$. Onthoud: kijk goed naar het teken (+ of -)."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-002",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{4}{5}$ - $\\frac{2}{5}$ =",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{2}{10}$", "$\\frac{6}{5}$", "$\\frac{2}{0}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_fifths",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 5,
            "fractions": [
              {"numerator": 4, "denominator": 5, "label": "4/5"},
              {"numerator": 2, "denominator": 5, "label": "2/5"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "4/5 - 2/5 = 2/5",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de tellers af: 4 - 2 = 2. De noemer blijft 5 — die verandert niet bij gelijknamige breuken. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$. Onthoud: bij gelijknamige breuken reken je alleen met de tellers, de noemer verandert niet.",
        "solutionSteps": [
          "Zijn de noemers gelijk? Ja, allebei 5 (gelijknamig)",
          "Trek de tellers af: 4 - 2 = 2",
          "De noemer blijft hetzelfde: 5",
          "Antwoord: $\\frac{2}{5}$"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 4 - 2 = 2, noemer blijft 5. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (5 + 5 = 10). Maar bij gelijknamige breuken blijft de noemer hetzelfde: 5. Je rekent alleen met de tellers: 4 - 2 = 2. Onthoud: de noemer verandert niet.",
          "2": "Je dacht waarschijnlijk dat je de tellers moet optellen (4 + 2 = 6) in plaats van aftrekken. Maar het minteken zegt: trek af. 4 - 2 = 2, dus $\\frac{2}{5}$. Onthoud: kijk goed naar het teken (+ of -).",
          "3": "Je dacht waarschijnlijk dat je de noemers ook moet aftrekken (5 - 5 = 0). Maar de noemer verandert niet bij gelijknamige breuken — hij blijft 5. Bovendien kan een noemer nooit 0 zijn (delen door nul mag niet)."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-003",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{3}{6}$ =",
      "context": null,
      "options": ["$\\frac{2}{6}$", "$\\frac{2}{12}$", "$\\frac{8}{6}$", "$\\frac{3}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_sixths",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 3, "denominator": 6, "label": "3/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 6,
            "label": "5/6 - 3/6 = 2/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de tellers af: 5 - 3 = 2. De noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$. Vereenvoudigd: $\\frac{2}{6}$ = $\\frac{1}{3}$. Onthoud: bij gelijknamige breuken verandert de noemer niet.",
        "solutionSteps": [
          "Zijn de noemers gelijk? Ja, allebei 6 (gelijknamig)",
          "Trek de tellers af: 5 - 3 = 2",
          "De noemer blijft hetzelfde: 6",
          "Antwoord: $\\frac{2}{6}$ (= $\\frac{1}{3}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 5 - 3 = 2, noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (6 + 6 = 12). Maar bij gelijknamige breuken blijft de noemer hetzelfde: 6. Onthoud: de noemer verandert niet bij gelijknamige breuken.",
          "2": "Je dacht waarschijnlijk dat je de tellers moet optellen (5 + 3 = 8) in plaats van aftrekken. Maar het minteken zegt: trek af. 5 - 3 = 2, dus $\\frac{2}{6}$. Onthoud: kijk goed naar het teken.",
          "3": "Je dacht waarschijnlijk dat het antwoord de tweede breuk is ($\\frac{3}{6}$). Maar je moet de tellers aftrekken: 5 - 3 = 2. Het antwoord is $\\frac{2}{6}$, niet $\\frac{3}{6}$. Onthoud: reken altijd uit, neem niet zomaar een getal over."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-004",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Er is $\\frac{7}{8}$ van een taart over. Je eet $\\frac{3}{8}$. Hoeveel taart is er nog over?",
      "context": null,
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_context",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 7,
            "denominator": 8,
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "Over: 7/8"},
              {"numerator": 3, "denominator": 8, "label": "Gegeten: 3/8"}
            ],
            "operator": "-",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8 van de taart is nog over",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Er was $\\frac{7}{8}$ over en je eet $\\frac{3}{8}$. Trek de tellers af: 7 - 3 = 4. De noemer (8 stukken) blijft hetzelfde. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$ (= $\\frac{1}{2}$, een halve taart). Onthoud: de noemer vertelt in hoeveel stukken de taart is verdeeld — dat verandert niet.",
        "solutionSteps": [
          "Hoeveel was er? $\\frac{7}{8}$ van de taart",
          "Hoeveel eet je op? $\\frac{3}{8}$ van de taart",
          "Trek de tellers af: 7 - 3 = 4",
          "De noemer blijft 8 (de taart is in 8 stukken)",
          "Antwoord: $\\frac{4}{8}$ = een halve taart"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 - 3 = 4, noemer blijft 8. Er is $\\frac{4}{8}$ (= een halve) taart over.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (8 + 8 = 16). Maar de taart is in 8 stukken verdeeld, niet 16. Bij gelijknamige breuken blijft de noemer hetzelfde. Onthoud: de noemer vertelt in hoeveel stukken de taart is verdeeld.",
          "2": "Je dacht waarschijnlijk dat je de tellers moet optellen (7 + 3 = 10). Maar je eet stukken op, dus trek af: 7 - 3 = 4. Bovendien kan $\\frac{10}{8}$ niet — je kunt niet meer dan een hele taart overhouden. Onthoud: opeten = aftrekken.",
          "3": "Je dacht waarschijnlijk dat $\\frac{3}{8}$ het antwoord is. Maar $\\frac{3}{8}$ is het deel dat je hebt gegeten, niet wat er over is. Trek af: $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$. Onthoud: lees goed wat de vraag vraagt."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-005",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "fill_in",
      "question": "Een fles is $\\frac{9}{10}$ vol. Je schenkt $\\frac{4}{10}$ uit. Welk deel van de fles is nog vol? Typ je antwoord als breuk (bijv. 3/10).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["5/10", "1/2"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "conceptId": "subtract_like_fractions_fill_context",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 9,
            "denominator": 10,
            "fractions": [
              {"numerator": 9, "denominator": 10, "label": "Vol: 9/10"},
              {"numerator": 4, "denominator": 10, "label": "Uitgeschonken: 4/10"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 10,
            "label": "9/10 - 4/10 = 5/10 = 1/2",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de tellers af: 9 - 4 = 5. De noemer blijft 10. Dus $\\frac{9}{10}$ - $\\frac{4}{10}$ = $\\frac{5}{10}$. Vereenvoudigd: $\\frac{5}{10}$ = $\\frac{1}{2}$ — de fles is nog half vol.",
        "solutionSteps": [
          "Trek de tellers af: 9 - 4 = 5",
          "De noemer blijft 10",
          "Antwoord: $\\frac{5}{10}$ (= $\\frac{1}{2}$)"
        ]
      }
    }
  ]
}